var service = function($rootScope, $http, $q, $location, $stateParams, InternalUserCheck, RetailerContext) {
  var filterParams = function(lookupType) {
    var lookup = $stateParams;
    var url = {
      'previous': $rootScope.previousUrl,
      'current': $location.$$url
    }[lookupType]
    if (!lookup) { return {}; }
    return {
        filter_category_id: lookup.category,
        filter_subcategory_id: lookup.subcategory,
        filter_product_type_id: lookup.type,
        filter_tag_text: [lookup.tagName],
        search_term: lookup.search || $stateParams.search,
        filter_distributor_ids: _.isEmpty(lookup.distributors) ? null : lookup.distributors,
        url: url,
        previous_collections: getPreviousCollections(),
        index_position: $stateParams.indexPosition
      };
  };

  var setPreviousCollections = function(params) {
    if (params.cid) {
      if (!$rootScope.previousCollections) { $rootScope.previousCollections = []; }
      if (_.indexOf($rootScope.previousCollections, params.cid) < 0) {
        $rootScope.previousCollections.push(params.cid);
      }
    }
  };

  var getPreviousCollections = function() {
    return _.isEmpty($rootScope.previousCollections) ? null : $rootScope.previousCollections
  };

  var prepareTags = function(productLine) {
    var ptags = _.filter(productLine.tags, function(t) { return t.primary; });
    var ntags = _.filter(productLine.tags, function(t) { return !t.primary; });
    return {
      'normal': _.compact(_.map(ntags, 'name')),
      'primary': _.compact(_.map(ptags, 'name'))
    };
  };

  return {
    filterParams: filterParams,
    trackClick: function(params, productLine, location) {
      // mostly noop
      setPreviousCollections(params);
    },
  };
};

service.$inject = ['$rootScope', '$http', '$q', '$location', '$stateParams', 'InternalUserCheck', 'RetailerContext'];

tiz.service('Tracking', service);
